// Main Server CMS Dashboard
// export const serverAddress  = "https://api.assertit.io/ipem";
export const serverAddress = "https://server.assertit.io/ipem";
// export const serverAddress = "http://localhost:4003/ipem";
// development-v2 commit
// Dev Server CMS Dashboard
// export const serverAddress = "https://api-dev.assertit.io/ipem";

// export const serverAddress = "http://15.206.124.141:3000/ipem"
 //"http://52.66.233.131:3000/ipem"
 

// Local Server
// export const serverAddress = "http://localhost:4001/ipem";

// export const serverAddress=process.env.REACT_APP_BASE_URL

export const originsRow = [
  "WebsitePopUp",
  "CollegeDunia",
  "OnlineQuery",
  "WalkIn",
  "AdPage",
  "Telephonic",
  "CollegeDekho",
  "GetAdmissionWalkIn",
  "CollegeDekhoWalkIn",
  "OtherConsultantWalkIn",
  "ExistingStudent",
];

export const programsColumn = [
  "BBA",
  "BCA",
  "BA.LLB",
  "LLB",
  "MBA",
  "B.COM(H)",
  "MCA",
  "B.ED",
  "B.COM.LLB",
  "D.El.Ed",
];

// Map each display origin to the canonical `form_location` value actually stored
// on lead documents. The role-scope dropdown saves `allowed_origins`, and the
// backend filters leads with `form_location: { $in: allowed_origins }`, so these
// values MUST match the stored slugs (lowercase-hyphenated) or scoped users see
// no leads. Keep in sync with the form_location values produced on lead creation.
export const originFormLocationMap = {
  WebsitePopUp: "website-pop-up",
  CollegeDunia: "college-dunia",
  OnlineQuery: "online-query",
  WalkIn: "walk-in",
  AdPage: "ad-page",
  Telephonic: "telephonic",
  CollegeDekho: "college-dekho-walk-in",
  GetAdmissionWalkIn: "get-admission-walk-in",
  CollegeDekhoWalkIn: "college-dekho-walk-in",
  OtherConsultantWalkIn: "other-consultant-walk-in",
  ExistingStudent: "existing-student",
};

export const originOptions = originsRow.map((origin) => ({
  value: originFormLocationMap[origin] ?? origin,
  label: origin,
}));

export const programScopeOptions = programsColumn.map((program) => ({
  value: program,
  label: program,
}));

export const feedbackOptions = [
  "Student Feedback",
  "Faculty Feedback",
  "Employer Feedback",
  "Alumni Feedback",
  "Parent Feedback",
  "Student Satisfaction",
];
